import React from 'react';
import Chart from 'react-apexcharts';

const STAGES = ['upload', 'collect-worker', 'mission-aggregator', 'mission-processor'];

/**
 * alignDurationByDay:
 *  - Finds all unique days
 *  - For each stage, builds an array of average_duration_seconds
 *    aligned with those days (null if missing)
 */
function alignDurationByDay(apiData) {
  const records = apiData.results || [];

  // 1) Gather all unique days, sorted
  const allDays = Array.from(new Set(records.map((r) => r.day))).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  // 2) Build a series for each stage
  const series = STAGES.map((stage) => {
    const dataArray = allDays.map((day) => {
      const found = records.find((r) => r.day === day && r.stage === stage);
      return found ? found.average_duration_seconds : null;
    });
    return {
      name: stage,
      data: dataArray,
    };
  });

  return { categories: allDays, series };
}

const DurationLineChart = ({ data }) => {
  const { categories, series } = alignDurationByDay(data);

  const options = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: true },
    },
    title: {
      text: 'Average Duration (seconds) over Time',
      align: 'center',
    },
    xaxis: {
      categories,
      title: { text: 'Day' },
    },
    yaxis: {
      title: { text: 'Avg Duration (s)' },
      min: 0, // or set an appropriate minimum
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    stroke: {
      curve: 'smooth', // optional for a smoother line
      width: 2,
    },
    legend: {
      position: 'bottom',
    },
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      <Chart options={options} series={series} type="line" height={350} />
    </div>
  );
};

export default DurationLineChart;
